import React from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Row,
  Col
} from 'reactstrap';
import { required } from '@src/validation';
import 'react-dates/initialize';
import { SingleDatePicker } from 'react-dates';
import 'react-dates/lib/css/_datepicker.css';
import moment from 'moment';
import LabelInput from '@components/LabelInput/LabelInput';
import axiosInstance from '@src/axios-instance';

const fieldValidator = {
  schedule_date: [required],
  schedule_time: [required]
};

class ScheduleModal extends React.Component {
  constructor(props) {
    super(props);
    const fields = {};
    fields['schedule_date'] = {
      value: moment().add(2, 'days'),
      visited: false,
      error: false
    };
    fields['schedule_time'] = {
      value: moment().format('HH:mm'),
      visited: false,
      error: false
    };

    this.state = { ...fields };
  }

  submitHandler = e => {
    e.preventDefault();
    return false;
  };

  updateForm = (event, name) => {
    const inputData = {
      value:
        event !== null && event.target !== undefined
          ? event.target.value
          : event,
      visited: true,
      error: false
    };

    for (let i = 0; i < fieldValidator[name].length; i++) {
      const validationMsg = fieldValidator[name][i](inputData.value);
      if (validationMsg !== undefined) {
        inputData.error = validationMsg;
        break;
      }
    }

    this.setState({
      [name]: inputData
    });
  };

  submitHandler = e => {
    e.preventDefault();
    const formData = this.state;
    const postData = JSON.parse(localStorage.getItem('schedulePost'));

    let isValid = true;

    Object.keys(fieldValidator).forEach(key => {
      postData[key] =
        typeof formData[key].value === 'object'
          ? formData[key].value.format('YYYY-MM-DD')
          : formData[key].value;
      for (let i = 0; i < fieldValidator[key].length; i++) {
        const validationMsg = fieldValidator[key][i](formData[key].value);
        formData[key].visited = true;
        if (validationMsg !== undefined) {
          formData[key].error = validationMsg;
          isValid = false;
          break;
        } else {
          formData[key].error = false;
        }
      }
    });
    if (
      !moment(
        postData['schedule_date'] + postData['schedule_time'],
        'YYYY-MM-DDHH:mm'
      ).isAfter(moment())
    ) {
      formData.schedule_date.error =
        'Please pick a different time in the future.';
      isValid = false;
    }
    this.setState({ ...formData });
    if (isValid) {
      this.props.loading(true);
      axiosInstance()
        .post(
          `/evidence-of-insurances/save-schedule/${this.props.entity.id}.json`,
          postData
        )
        .then(response => {
          this.props.getEntity();
          this.props.onSuccess('EOI email schedule created');
          this.props.loading(false);
          this.props.toggle();
        })
        .catch(err => {
          this.props.loading(false);
        });
    }

    return false;
  };

  render = () => {
    console.log(moment().format('YYYY-MM-DD HH:mm'));
    return (
      <Modal
        isOpen={this.props.isActive}
        toggle={this.props.toggle}
        className={this.props.className}
      >
        <form
          ref={c => {
            this.form = c;
          }}
          onSubmit={this.submitHandler.bind(this)}
        >
          <ModalHeader toggle={this.props.toggle}>{'Email'}</ModalHeader>
          <div className={'position-relative'}>
            <ModalBody className={'p-4'}>
              <Row>
                <Col>
                  <div className={'form-group'}>
                    <label className={'font-weight-bold'}>Date *</label>
                    <div
                      className={
                        this.state.schedule_date.error ? 'is-invalid' : ''
                      }
                    >
                      <SingleDatePicker
                        date={this.state.schedule_date.value} // momentPropTypes.momentObj or null
                        onDateChange={issueDate =>
                          this.updateForm(issueDate, 'schedule_date')
                        } // PropTypes.func.isRequired
                        focused={this.state.focused} // PropTypes.bool
                        block={true}
                        isOutsideRange={day => {
                          return (
                            !day.isAfter(moment()) &&
                            !day.isSame(moment(), 'day')
                          );
                        }}
                        onFocusChange={({ focused }) =>
                          this.setState({ focused })
                        } // PropTypes.func.isRequired
                        id="schedule_date" // PropTypes.string.isRequired,
                      />
                    </div>
                    {this.state.schedule_date.error && (
                      <span className={'error'}>
                        {this.state.schedule_date.error}
                      </span>
                    )}
                  </div>
                </Col>
                <Col>
                  <LabelInput
                    name={'Time'}
                    type={'time'}
                    required={true}
                    {...this.state.schedule_time}
                    onChange={event => this.updateForm(event, 'schedule_time')}
                  />
                </Col>
              </Row>
            </ModalBody>
            <ModalFooter className={'py-4 justify-content-end'}>
              <Button
                color="light"
                className={'btn px-3'}
                onClick={this.props.onBackClick}
              >
                &lsaquo;&nbsp;Back
              </Button>
              <Button color="primary" className={'btn px-3'} type={'submit'}>
                Schedule
              </Button>
            </ModalFooter>
          </div>
        </form>
      </Modal>
    );
  };
}
export default ScheduleModal;
